import { render } from "./DetailsFileField.vue?vue&type=template&id=12e1d2da&scoped=true&ts=true"
import script from "./DetailsFileField.vue?vue&type=script&lang=ts"
export * from "./DetailsFileField.vue?vue&type=script&lang=ts"

import "./DetailsFileField.vue?vue&type=style&index=0&id=12e1d2da&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12e1d2da"]])

export default __exports__